module.exports = __webpack_public_path__ + "img/tw.7f9769bb.svg";